import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisV, faFilePdf } from "@fortawesome/free-solid-svg-icons";
import Table from "react-bootstrap/Table";
import { BodyAsFormData } from "../../../services/utilities/util";
import FilterContext from "../../../routes/FilterContext";
import { apiMiddleware } from "../../../services/apis/apiMiddleware";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import jsPDF from "jspdf";
import "jspdf-autotable";
import md5 from "md5";
import { downloadPdf } from "../../../services/utilities/util";
import { connect } from "react-redux";
import { Modal } from "react-bootstrap";
import SearchDateBox from "../../SearchDateBox";
import { JsonToExcel } from "react-json-to-excel";
import { convertJsonForExcel } from "../../../services/utilities/util";
function mapStateToProps(state) {
  return { filters: state.selectedFilters };
}
class AssetMarketAnalysis extends React.Component {
  static contextType = FilterContext;

  state = {
    mode: "yearly",
    modeText: "Switch To Quarterly",
    gradeText: "Switch To All Grade",
    grade: "AA+",
    assetMarketAnalysis: [],
    filters: "",
    showLoader: false,
    showGraph: false,
    start_date: "",
    end_date: "",
    which_date: "",
    which_date_name: "",
    noteTxt: "",
    jsonForExcel: [],
    macromarket: "",
    excelData: [],
    isNotesmodal: false,
    excelHeaders: {
      year_quarter: { name: "Years/Quarters", type: "string" },
      city_stock: { name: "City - Stock (msf)", type: "string" },
      macromarket_stock: { name: "Macromarket - Stock (msf)", type: "string" },
      city_net_supply: { name: "City - Net Supply (msf)", type: "string" },
      macromarket_net_supply: {
        name: "Macromarket - Net Supply (msf)",
        type: "string",
      },
      city_leasing: { name: "City - Gross Leasing (msf)", type: "string" },
      macromarket_leasing: {
        name: "Macromarket - Gross Leasing (msf)",
        type: "string",
      },
      city_absorption: {
        name: "City - Gross Absorption (msf)",
        type: "string",
      },
      macromarket_absorption: {
        name: "Macromarket - Gross Absorption (msf)",
        type: "string",
      },
      city_surrendered: { name: "City - Surrendered (msf)", type: "string" },
      macromarket_surrendered: {
        name: "Macromarket - Surrendered (msf)",
        type: "string",
      },
      city_vacancy: { name: "City - Vacancy (%)", type: "string" },
      macromarket_vacancy: {
        name: "Macromarket - Vacancy (%)",
        type: "string",
      },
    },
  };

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.setState({ showLoader: true, showGraph: false });
    var filters;
    if (JSON.stringify(this.props.filters) == "{}") {
      filters = JSON.stringify(this.context.filters);
    } else {
      filters = JSON.stringify(this.props.filters);
    }
    // this.state.filters = filters;
    this.setState({ filters: filters });

    apiMiddleware
      .post(
        "api/edge/office/get_asset_market_analysis",
        BodyAsFormData(filters)
      )
      .then((res) => {
        this.setState({ showLoader: false, showGraph: true });
        if ("error" in res) {
          console.log("11");
          this.setState(
            {
              assetMarketAnalysis: res.error[0],
            },
            () => {}
          );
        } else {
          this.setState(
            {
              assetMarketAnalysis: res.data.result,
              excelData: res.data.result,
              macromarket: res.data.result[0]["macromarket_absorption"],
              noteTxt: res.data.micromarket,
            },
            () => {}
          );
        }
      });
  }

  componentDidUpdate() {
    if (this.props.filters != this.state.filters) {
      var body = new FormData();
      body.append("filter", JSON.stringify(this.props.filters));
      if (
        this.state.end_date.length > 0 &&
        this.state.end_date != "ull" &&
        this.state.start_date.length > 0 &&
        this.state.start_date != "ull" &&
        this.state.which_date.length > 0
      ) {
        body.append("end_date", this.state.end_date);
        body.append("start_date", this.state.start_date);
        body.append("which_date", this.state.which_date);
        body.append("mode", this.state.mode);
        body.append("grade", this.state.grade);
      } else if (typeof this.props.bodyParams != "undefined") {
        body = this.props.bodyParams;
      }
      this.setState({
        bodyParams: body,
      });
      this.setState({ filters: this.props.filters });
      this.setState({ showLoader: true, showGraph: false });

      apiMiddleware
        .post("api/edge/office/get_asset_market_analysis", body)
        .then((res) => {
          this.setState({ showLoader: false, showGraph: true });
          if ("error" in res) {
            this.setState(
              {
                assetMarketAnalysis: res.error[0],
              },
              () => {}
            );
          } else {
            this.setState(
              {
                assetMarketAnalysis: res.data.result,
                excelData: res.data.result,
                macromarket: res.data.result[0]["macromarket_absorption"],
                noteTxt: res.data.micromarket,
              },
              () => {}
            );
          }
        });
    }
  }

  dateFilter = (dateValue) => {
    this.setState({
      start_date: dateValue.startDate,
      end_date: dateValue.endDate,
      which_date: dateValue.dateType,
      which_date_name: dateValue.dateTypeName,
      filters: "",
      isOpen: false,
    });
  };

  openModal = () => {
    this.setState({ isOpen: true });
  };

  closeModal = () => this.setState({ isOpen: false });

  openNotesModal = () => {
    this.setState({ isNotesmodal: true });
  };

  closeNotesModal = () => this.setState({ isNotesmodal: false });

  getModeData() {
    if (this.state.mode == "yearly") {
      this.setState({ mode: "quarterly" }, () => {
        var body = new FormData();
        body.append("filter", JSON.stringify(this.props.filters));
        body.append("mode", this.state.mode);
        body.append("grade", this.state.grade);
        if (
          this.state.end_date.length > 0 &&
          this.state.end_date != "ull" &&
          this.state.start_date.length > 0 &&
          this.state.start_date != "ull" &&
          this.state.which_date.length > 0
        ) {
          body.append("end_date", this.state.end_date);
          body.append("start_date", this.state.start_date);
          body.append("which_date", this.state.which_date);
        }
        apiMiddleware
          .post("api/edge/office/get_asset_market_analysis", body)
          .then((res) => {
            this.setState({ showLoader: false, showGraph: true });
            if ("error" in res) {
              this.setState(
                {
                  assetMarketAnalysis: res.error[0],
                },
                () => {}
              );
            } else {
              this.setState(
                {
                  assetMarketAnalysis: res.data.result,
                  excelData: res.data.result,
                  macromarket: res.data.result[0]["macromarket_absorption"],
                  noteTxt: res.data.micromarket,
                },
                () => {}
              );
            }
          });
      });
    } else if (this.state.mode == "quarterly") {
      this.setState({ mode: "yearly" }, () => {
        var body = new FormData();
        body.append("filter", JSON.stringify(this.props.filters));
        body.append("mode", this.state.mode);
        body.append("grade", this.state.grade);
        if (
          this.state.end_date.length > 0 &&
          this.state.end_date != "ull" &&
          this.state.start_date.length > 0 &&
          this.state.start_date != "ull" &&
          this.state.which_date.length > 0
        ) {
          body.append("end_date", this.state.end_date);
          body.append("start_date", this.state.start_date);
          body.append("which_date", this.state.which_date);
        }
        apiMiddleware
          .post("api/edge/office/get_asset_market_analysis", body)
          .then((res) => {
            this.setState({ showLoader: false, showGraph: true });
            if ("error" in res) {
              this.setState(
                {
                  assetMarketAnalysis: res.error[0],
                },
                () => {}
              );
            } else {
              this.setState(
                {
                  assetMarketAnalysis: res.data.result,
                  excelData: res.data.result,
                  macromarket: res.data.result[0]["macromarket_absorption"],
                  noteTxt: res.data.micromarket,
                },
                () => {}
              );
            }
          });
      });
    }

    if (this.state.modeText == "Switch To Quarterly") {
      this.setState({ modeText: "Switch To Yearly" });
    } else if (this.state.modeText == "Switch To Yearly") {
      this.setState({ modeText: "Switch To Quarterly" });
    }
  }

  getGradeWiseData() {
    if (this.state.grade == "All") {
      this.setState({ grade: "AA+" }, () => {
        var body = new FormData();
        body.append("filter", JSON.stringify(this.props.filters));
        body.append("grade", this.state.grade);
        body.append("mode", this.state.mode);
        if (
          this.state.end_date.length > 0 &&
          this.state.end_date != "ull" &&
          this.state.start_date.length > 0 &&
          this.state.start_date != "ull" &&
          this.state.which_date.length > 0
        ) {
          body.append("end_date", this.state.end_date);
          body.append("start_date", this.state.start_date);
          body.append("which_date", this.state.which_date);
        }
        apiMiddleware
          .post("api/edge/office/get_asset_market_analysis", body)
          .then((res) => {
            this.setState({ showLoader: false, showGraph: true });
            this.setState({ assetMarketAnalysis: res.data.result });
          });
      });
    } else if (this.state.grade == "AA+") {
      this.setState({ grade: "All" }, () => {
        var body = new FormData();
        body.append("filter", JSON.stringify(this.props.filters));
        body.append("grade", this.state.grade);
        body.append("mode", this.state.mode);
        if (
          this.state.end_date.length > 0 &&
          this.state.end_date != "ull" &&
          this.state.start_date.length > 0 &&
          this.state.start_date != "ull" &&
          this.state.which_date.length > 0
        ) {
          body.append("end_date", this.state.end_date);
          body.append("start_date", this.state.start_date);
          body.append("which_date", this.state.which_date);
        }
        apiMiddleware
          .post("api/edge/office/get_asset_market_analysis", body)
          .then((res) => {
            this.setState({ showLoader: false, showGraph: true });
            this.setState({ assetMarketAnalysis: res.data.result });
          });
      });
    }

    if (this.state.gradeText == "Switch To All Grade") {
      this.setState({ gradeText: "Switch To AA+" });
    } else if (this.state.gradeText == "Switch To AA+") {
      this.setState({ gradeText: "Switch To All Grade" });
    }
  }

  render() {
    const data = {};
    data.startDate = this.state.start_date;
    data.endDate = this.state.end_date;
    data.dateType = this.state.which_date;
    data.dateTypeName = this.state.which_date_name;
    return (
      <div className="widget widgetTable">
        {this.state.showLoader && (
          <div className="row">
            <div className="col-lg-12 text-center">
              <img src="/edge/images/edgeLoader.gif" />
            </div>
          </div>
        )}
        {this.state.showGraph && (
          <>
            <div className="row">
              <div className="col-lg-9 text-start colorLightBlue widgetTableHeader">
                <p>
                  Asset Market Analysis{" "}
                  {this.state.macromarket && <>({this.state.macromarket})</>}
                </p>
              </div>
              <div className="col-lg-3 text-end">
                <p className="colorBlack downloads">
                  <FontAwesomeIcon icon={faEllipsisV} />
                  <ul className="downloadOptions">
                    <li
                      className="excelDownload"
                      onClick={(e) => {
                        let body = new FormData();
                        body.append("path", window.location.pathname);
                        body.append("action", "excel_export");
                        body.append("count", 1);
                        body.append(
                          "hash",
                          window.location.search.split("?").pop()
                        );
                        body.append("screen_sub_type", "Asset Market Analysis");
                        apiMiddleware
                          .post(process.env.REACT_APP_USER_ACTIVITY, body)
                          .then((res) => {
                            console.log(res);
                          });
                      }}
                    >
                      <JsonToExcel
                        title="Download as Excel"
                        data={convertJsonForExcel(
                          this.state.assetMarketAnalysis,
                          this.state.excelHeaders
                        )}
                        fileName="assetMarketAnalysis"
                        btnClassName="download-table-xls-button"
                      />
                    </li>
                    <li
                      className="pdfDownload"
                      onClick={(e) => {
                        downloadPdf(
                          "#assetMarketAnalysis",
                          "assetMarketAnalysis"
                        );
                        let body = new FormData();
                        body.append("path", window.location.pathname);
                        body.append("action", "pdf_download");
                        body.append("count", 1);
                        body.append(
                          "hash",
                          window.location.search.split("?").pop()
                        );
                        body.append("screen_sub_type", "Asset Market Analysis");
                        apiMiddleware
                          .post(process.env.REACT_APP_USER_ACTIVITY, body)
                          .then((res) => {
                            console.log(res);
                          });
                      }}
                    >
                      <FontAwesomeIcon icon={faFilePdf} /> Download as PDF
                    </li>
                    <li
                      className="pdfDownload"
                      onClick={(e) => {
                        this.openModal();
                      }}
                    >
                      Select Date Range
                    </li>
                    <li
                      className="pdfDownload"
                      onClick={(e) => {
                        this.getModeData();
                      }}
                    >
                      {this.state.modeText}
                    </li>
                    <li
                      className="pdfDownload"
                      onClick={(e) => {
                        this.getGradeWiseData();
                      }}
                    >
                      {this.state.gradeText}
                    </li>
                    <li
                      className="pdfDownload"
                      onClick={(e) => {
                        this.openNotesModal();
                      }}
                    >
                      Notes to Chart
                    </li>
                  </ul>
                </p>
              </div>
              {this.state.assetMarketAnalysis !=
                "Table only available when Assets selected belong to same Macro-market" &&
                this.state.assetMarketAnalysis != "hide" && (
                  <div className="col-lg-12 mt-2 newFixedTable">
                    <Table
                      className="assetMarketAnalysis"
                      responsive
                      hover
                      id="assetMarketAnalysis"
                    >
                      <thead>
                        {/* <tr className="">
                          <th></th>
                          <th
                            colSpan={"2"}
                            className="text-center thBorderBottom"
                          >
                            Stock (msf)
                          </th>
                          <th
                            colSpan={"2"}
                            className="text-center thBorderBottom"
                          >
                            Net Supply (msf)
                          </th>
                          <th
                            colSpan={"2"}
                            className="text-center thBorderBottom"
                          >
                            Gross Leasing (msf)
                          </th>
                          <th
                            colSpan={"2"}
                            className="text-center thBorderBottom"
                          >
                            Gross Absorption (msf)
                          </th>
                          <th
                            colSpan={"2"}
                            className="text-center thBorderBottom"
                          >
                            Surrendered (msf)
                          </th>
                          <th
                            colSpan={"2"}
                            className="text-center thBorderBottom"
                          >
                            Vacancy (%)
                          </th>
                        </tr> */}
                        <tr className="">
                          <th></th>
                          <th
                            colSpan={"2"}
                            className="text-center thBorderBottom"
                          >
                            <span>Stock</span>
                          </th>
                          <th
                            colSpan={"2"}
                            className="text-center thBorderBottom"
                          >
                            <span>Net Supply</span>
                          </th>
                          <th
                            colSpan={"2"}
                            className="text-center thBorderBottom"
                          >
                            <span>Gross Leasing</span>
                          </th>
                          <th
                            colSpan={"2"}
                            className="text-center thBorderBottom"
                          >
                            <span> Gross Absorption</span>
                          </th>
                          <th
                            colSpan={"2"}
                            className="text-center thBorderBottom"
                          >
                            <span>Surrendered</span>
                          </th>
                          <th
                            colSpan={"2"}
                            className="text-center thBorderBottom"
                          >
                            <span>Vacancy</span>
                          </th>
                        </tr>
                        <tr className="thwithNoPadding">
                          <th></th>
                          <th
                            colSpan={"2"}
                            className="text-center thBorderBottom"
                          >
                            <b>(msf)</b>
                          </th>
                          <th
                            colSpan={"2"}
                            className="text-center thBorderBottom"
                          >
                            <b>(msf)</b>
                          </th>
                          <th
                            colSpan={"2"}
                            className="text-center thBorderBottom"
                          >
                            <b>(msf)</b>
                          </th>
                          <th
                            colSpan={"2"}
                            className="text-center thBorderBottom"
                          >
                            <b>(msf)</b>
                          </th>
                          <th
                            colSpan={"2"}
                            className="text-center thBorderBottom"
                          >
                            <b>(msf)</b>
                          </th>
                          <th
                            colSpan={"2"}
                            className="text-center thBorderBottom"
                          >
                            <b>(%)</b>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.assetMarketAnalysis.map((row, i) => (
                          <tr className="">
                            {Object.values(row).map((val) => (
                              <td className="text-end">{val}</td>
                            ))}
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                )}
              {[
                "Table only available when Assets selected belong to same Macro-market",
                "hide",
              ].includes(this.state.assetMarketAnalysis) && (
                <p className="text-center my-3" style={{ color: "#000" }}>
                  Table only available when Assets selected belong to same
                  Macro-market
                </p>
              )}
            </div>
            <div className="row">
              <div className="col-lg-12 chartSearchBox">
                <Modal
                  show={this.state.isOpen}
                  onHide={this.closeModal}
                  className="columnsModal selectColumn downloadImgModal chartModal"
                  size="lg"
                >
                  <Modal.Body>
                    <SearchDateBox
                      datechildFilter={this.dateFilter}
                      parentData={data}
                    />
                  </Modal.Body>
                </Modal>
              </div>
              <div className="col-lg-12 chartSearchBox">
                <Modal
                  show={this.state.isNotesmodal}
                  onHide={this.closeNotesModal}
                  className="columnsModal selectColumn downloadImgModal chartModal"
                  size="md"
                >
                  <p
                    style={{
                      padding: "10px",
                      background: "#4c8fea",
                      fontWeight: "600",
                      color: "#fff",
                      fontSize: "18px",
                      fontFamily: "Poppins",
                    }}
                  >
                    Notes
                  </p>
                  <Modal.Body style={{ padding: "15px" }}>
                    <p className="mt-3" style={{ color: "#000" }}>
                      Data as per latest month end*
                    </p>
                    <p className="mt-3" style={{ color: "#000" }}>
                      <span style={{ fontWeight: "600" }}>
                        {"Micromarkets: "}
                      </span>
                      {this.state.noteTxt}
                    </p>
                  </Modal.Body>
                </Modal>
              </div>
            </div>
          </>
        )}
      </div>
    );
  }
}

export default connect(mapStateToProps)(AssetMarketAnalysis);
